import React from "react";
import ChooseCardForm from "../../../../components/CheckoutForm/ChooseCardForm";
import PaymentCard from "../../../../model/PaymentCard";
import BillJavaScriptDTO from "@tootsweet/model/datatransfer/BillDTO";
import { payBill } from "../../api";
import { tt } from "../../../../utils/i18n/i18n";
import TSUtils from "../../../../utils/helpers/TSUtils";
import CurrencySubUnitsMap from "../../../../model/CurrencySubUnitsMap";

interface Props {
  paymentCards: PaymentCard[];
  businessUserId: string;
  bill: BillJavaScriptDTO;
  currencySubUnits: CurrencySubUnitsMap;
  onPaymentSuccess: (paymentIntentId: string | undefined | null) => Promise<void>;
  onPaymentError: (error: Error | string) => Promise<void>;
  onAddCard: () => Promise<void>;
}

export default function ChooseCardStep(props: Props) {
  const formattedAmount = TSUtils.formatAmount(
    props.bill.amount,
    props.currencySubUnits[props.bill.currency || "EUR"],
    false,
    props.bill.currency || "EUR"
  );

  return (
    <ChooseCardForm
      paymentCards={props.paymentCards}
      businessUserId={props.businessUserId}
      posaDeliveryIds={[]}
      amount={props.bill.amount}
      goToInsertCard={props.onAddCard}
      afterPaymentSuccessful={props.onPaymentSuccess}
      onPaymentError={props.onPaymentError}
      formattedButtonText={tt("pay_bill_button", {
        amount: formattedAmount
      })}
      shouldUseSetupIntent={false}
      customPaymentHandler={async (cardId: string) => {
        const result = await payBill(
          props.bill._id,
          props.businessUserId,
          cardId
        );
        return { paymentIntentId: result?.paymentIntentId || "" };
      }}
    />
  );
}
